import ChangePasswordViewModelT from '@/ViewModels/Views/ChangePasswordViewModel';
import ViewFactory from '@/Factories/ViewFactory';
import ComponentManager from '@/Management/ComponentManager';
import NavigationService from '@/Management/NavigationService';
export default class ChangePasswordViewFactory extends ViewFactory {
    public viewModel: any;
    public view: any;
    private ChangePasswordViewModel: any;
    private ChangePasswordView: any;
    constructor(protected params: any) {
        super(params);
        this.ChangePasswordViewModel = ComponentManager.getViewModel<typeof ChangePasswordViewModelT>('ChangePasswordViewModel');
        this.ChangePasswordView = ComponentManager.getView('ChangePasswordView');
    }
    public getRegion(): string {
        return 'Modal';
    }
    public getView(): any {
        if (this.viewModel == null) {
            this.viewModel = new this.ChangePasswordViewModel({ viewFactory: this, allowClose: this.params.allowClose, onClose: this.params.onClose });
        }
        if (this.view == null) {
            this.view = new this.ChangePasswordView(this.viewModel, this.createRootElement('ChangePassword'));
        }
        let tuple = this.view.getTuple();
        return tuple.view;
    }
}

ComponentManager.setFactory('ChangePassword', ChangePasswordViewFactory, 'RADPresentation.HTMLClient.DefaultViewExtensions');
ComponentManager.setFactory('CHANGE_PASSWORD', ChangePasswordViewFactory, 'RADPresentation.HTMLClient.DefaultViewExtensions');